const passwordEl = document.querySelector("input[type='password']");
const passwordVisibilityToggleBtn = document.getElementById("password-display__toggle-btn");
const showPasswordIcon = passwordVisibilityToggleBtn.querySelector("svg.icon-show-password");
const hidePasswordIcon = passwordVisibilityToggleBtn.querySelector("svg.icon-hide-password");

function togglePassworVisibility(){
    if (passwordVisibilityToggleBtn.classList.contains("password-hidden")){
        passwordEl.setAttribute("type", "text");
    }else{
        passwordEl.setAttribute("type", "password");
    }
    passwordVisibilityToggleBtn.classList.toggle("password-hidden")
    showPasswordIcon.classList.toggle("hidden");
    hidePasswordIcon.classList.toggle("hidden");
}

passwordVisibilityToggleBtn.addEventListener("click", togglePassworVisibility);